export default "__VITE_ASSET__BthWxK8o__"